import DownArrow from '../vectors/DownArrow';
import UpArrow from '../vectors/UpArrow';

export default function ButtonSVG({ onClick, expand = false, dataTest }) {
  return (
    <button
      onClick={onClick}
      type="button"
      data-test={dataTest}
      className={
        'p-0 text-pirmary-blue border-0 rounded-full w-full bg-transparent hover:bg-gray-100 cursor-pointer max-xs:focus:outline-none max-xs:focus:bg-transparent'
      }
    >
      <span className="w-full display-[inherit] justify-center ">
        <span className={'w-full '}>
          {expand ? <UpArrow /> : <DownArrow />}
        </span>
      </span>
    </button>
  );
}
